
import { CashInVirgoComponent } from '@components/module/cico/customer-topup virgo/ci-virgo.component';
import UnauthorizedPage from '@pages/404.page';
import { Role } from '@shared/constants';
import { getAuthData } from '@store/entities/auth';
import React from 'react'
import { useSelector } from 'react-redux';

const CashInVirgoPage = () => {
  const { auth } = useSelector(getAuthData);
  const role = auth?.UserRole[0]?.name;
  let renderPage = <UnauthorizedPage />


  if (auth) {
    switch (role) {
      case Role?.USER_SUPER_ADMIN:
        renderPage = <CashInVirgoComponent />
        break;
      default:
        break;
    }
  }
  return <>{renderPage}</>
}

export default CashInVirgoPage